import { render, staticRenderFns } from "./BadRequest.vue?vue&type=template&id=679e5230&scoped=true"
import script from "./BadRequest.vue?vue&type=script&lang=js"
export * from "./BadRequest.vue?vue&type=script&lang=js"
import style0 from "./BadRequest.vue?vue&type=style&index=0&id=679e5230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679e5230",
  null
  
)

export default component.exports